module.exports = __webpack_public_path__ + "img/leadership.b0722541.png";